/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import React, { useState, useRef } from 'react';
import { Row, Col, Form, Button } from 'react-bootstrap';
import { OTPInputComp } from './components';
import * as S from './styles';
//import "../styles.css";

export interface IOTPCompProps {
  fields?: any;
  submitButtonLabel?: string;
  onFormSubmit?(payload: any): void;
  renderSubmitButton?(): void;
  labelColor?: string;
  onResendClick?(): void;
}

export const OTPComp = (props: IOTPCompProps) => {
  const {
    fields,
    submitButtonLabel,
    onFormSubmit,
    renderSubmitButton,
    onResendClick,
  } = props;
  const [formData, updateFormData] = useState<any>({});
  const [validated, setValidated] = useState(false);
  const [errors, setErrors] = useState<any>({});
  const [counter, setCounter] = useState(180);

  React.useEffect(() => {
    counter > 0 && setTimeout(() => setCounter(counter - 1), 1000);
  }, [counter]);

  const onOtpResendClick = () => {
    setCounter(180);
    onResendClick && onResendClick();
  };

  const _renderSubmitButton = () => {
    if (renderSubmitButton) {
      return renderSubmitButton();
    }
    return (
      <div className="mt-3">
        <Button
          variant="secondary"
          type="submit"
          className="mt-2 animate-up-2"
          style={{
            width: '50%',
            borderRadius: '0px',
            height: '40px',
            fontWeight: 'bold',
          }}
        >
          {submitButtonLabel}
        </Button>
      </div>
    );
  };

  const handleSubmit = (e?: any) => {
    const form = e.currentTarget;
    const isValid = form.checkValidity();
    e.preventDefault();
    e.stopPropagation();
    let hasError = false;

    const errorsObj: any = {};
    if (fields?.phoneNumber?.required && !formData[fields?.phoneNumber?.id]) {
      errorsObj[fields.phoneNumber.id] = true;
      hasError = true;
    }
    // if (field?.type === "otp") {
    //     if (
    //         field?.compProps?.required &&
    //         !formData[field?.compProps?.id]
    //     ) {
    //         errorsObj[field.compProps.id] = true;
    //         hasError = true;
    //     }
    // }
    setValidated(true);
    console.log('errorsObj', formData, errorsObj);
    if (!hasError && isValid) {
      setErrors({});
      onFormSubmit && onFormSubmit(formData);
    } else {
      window?.scrollTo(0, 0);
      setErrors(errorsObj);
    }
  };
  const handleCompChange = (id: string, payload: any) => {
    if (id && payload && errors[id]) {
      delete errors[id];
    }
    updateFormData({
      ...formData,
      [id]: payload,
    });
  };
  const _renderLayout = () => {
    return (
      <Row key={`layout-1-row-default-layout`}>
        <Col key={`layout-1-columns-email`} sm={12} className="mb-3">
          <OTPInputComp {...fields?.otp} onCompChange={handleCompChange} />
        </Col>
      </Row>
    );
  };
  return (
    <>
      <Form
        noValidate
        validated={validated}
        className="mt-4"
        onSubmit={handleSubmit}
      >
        <>
          {_renderLayout()}
          {/*{_renderFormGroup()}*/}
          {_renderSubmitButton()}
        </>
      </Form>
      <div>
        {counter > 0 ? (
          <S.TimerText>{`Did not receive the one time password? resend in ${counter} seconds`}</S.TimerText>
        ) : (
          <S.ResendText onClick={onOtpResendClick}>{`Resend OTP`}</S.ResendText>
        )}
      </div>
    </>
  );
};

OTPComp.defaultProps = {
  fields: {
    otp: {
      id: 'otp',
      label: 'Enter OTP',
      required: true,
      errorText: 'OTP is required',
    },
  },
};
